import { useEffect } from 'react';

const useWindowResize = ({ callback, timeout = 100 }: { callback: () => void; timeout: number }) => {
  useEffect(() => {
    const handleResize = () => {
      callback();
    };

    window.addEventListener('resize', handleResize);
    setTimeout(() => callback(), timeout);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [callback, timeout]);
};

export default useWindowResize;
